
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/changelog.md?watch=parent';
    export const toc = [{"id":"更新日志","depth":1,"title":"更新日志"},{"id":"100","depth":2,"title":"1.0.0"},{"id":"功能-","depth":3,"title":"功能 ✨"}];
export const frontmatter = {"title":"更新日志","toc":"menu","filename":"pages/changelog.md","lastUpdated":1773907276000};